import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {selectZoomState, viewActions} from "../view/viewSlice";
import Konva from "konva";
import {EditorTool} from "../../models/enums";
import {selectActiveTool} from "../config/configSlice";
import {useBasePan} from "../../../../../base-konva/features/pan";
import {useDoubleTap} from "../../../../../base-konva/features/pan/useDoubleTap";
import {useZoomActions} from "../view/useZoomActions";

const TOUCH_DRAWING_TOOLS = new Set<EditorTool>([
	EditorTool.PEN, EditorTool.ARC, EditorTool.COUNT,
	EditorTool.TEXT, EditorTool.RULER, EditorTool.IMAGE,
	EditorTool.LENGTH, EditorTool.AREA, EditorTool.VOLUME,
	EditorTool.TOP_VIEW_WALL_AREA, EditorTool.GROUP_MEASUREMENT_SELECT,
	EditorTool.SCALE, EditorTool.SCALE_INFO,
]);

type UsePanProps = {
	stageRef: React.RefObject<Konva.Stage>;
}

export function usePan({stageRef}: UsePanProps) {

	const dispatch = useDispatch();
	const activeTool = useSelector(selectActiveTool);
	const zoomState = useSelector(selectZoomState);
	const {handleZoomFitToScreen: handleZoomFitToScreenBase} = useZoomActions();
	const handleZoomFitToScreen = () => handleZoomFitToScreenBase(stageRef)

	const setZoomState = (value: typeof zoomState) => dispatch(viewActions.setZoomState(value))

	const {onMouseDown, onTouchStart, panInProgress} = useBasePan({
		stageRef,
		canScroll: () => activeTool !== EditorTool.PEN && activeTool !== EditorTool.GROUP_MEASUREMENT_SELECT,
		viewportSize: zoomState.viewportSize,
		zoomState,
		setZoomState,
	})

	const {onTouchEnd: onDoubleTapTouchEnd} = useDoubleTap({
		zoomState,
		setZoomState,
		stageRef,
		handleZoomFitToScreen,
	})

	const onTouchEnd = (evt: Konva.KonvaEventObject<TouchEvent>) => {
		if (!TOUCH_DRAWING_TOOLS.has(activeTool)) {
			onDoubleTapTouchEnd(evt)
		}
	}

	useEffect(() => {
		dispatch(viewActions.setPanInProgress(panInProgress));
	}, [panInProgress, dispatch]);

	return {
		onMouseDown,
		onTouchStart,
		onTouchEnd,
	}
}
